import { Link } from "react-router";
import { mensagemDoConsole } from "../../nucleo/console";
import { usePedirExportacao, type PedidoDeExportacao } from "../../nucleo/operacao";
import { podeNaSessao, useSessao } from "../../nucleo/sessao";
import { Aviso, Botao } from "../ui";

/**
 * Pede a exportação em segundo plano de um recorte (a fila ou um relatório). O arquivo é gerado
 * fora da tela: a pessoa recebe um aviso por e-mail e baixa em "Exportações", com o link valendo
 * por tempo limitado. Só aparece para quem tem `exportacao:gerar`.
 */
export function PedirExportacao({
  pedido,
  rotulo = "Exportar em segundo plano",
}: {
  pedido: PedidoDeExportacao;
  rotulo?: string;
}) {
  const sessao = useSessao();
  const exportar = usePedirExportacao();
  if (!podeNaSessao(sessao.data, "exportacao:gerar")) return null;
  return (
    <div className="inline-flex flex-col gap-2" data-testid="pedir-exportacao">
      <Botao
        variante="fantasma"
        disabled={exportar.isPending}
        onClick={() => exportar.mutate(pedido)}
      >
        {exportar.isPending ? "Pedindo…" : rotulo}
      </Botao>
      {exportar.isSuccess ? (
        <Aviso tom="sucesso">
          Pedido recebido. Avisamos por e-mail quando o arquivo ficar pronto; ele também aparece em{" "}
          <Link to="/admin/exportacoes">Exportações</Link>.
        </Aviso>
      ) : null}
      {exportar.isError ? <Aviso tom="erro">{mensagemDoConsole(exportar.error)}</Aviso> : null}
    </div>
  );
}
